import type { RootState } from '@/app/store';
import type { Site } from '../utils/assetHierarchy.types';

export const selectAssetHierarchyLoading = (state: RootState): boolean =>
  state.assetHierarchy.loading;

export const selectAssetHierarchy = (state: RootState): Site[] =>
  state.assetHierarchy.assetHierarchy;
